<template>
  <div class="check-wrapper smart-map" :class="`checkbox-${size}`">
    <div class="check-wrapper__item">
      <label class="container2" style="width: 100%;">
        <div class="check">
          <input type="checkbox" style="width: auto;" v-model="current" /><span
            class="checkmark"
          ></span
          ><span class="name">
            <slot>
              {{ label }}
            </slot>
          </span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    current: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-sm {
  .check-wrapper__item {
    .container2 {
      .check {
        .checkmark {
          width: 15px;
          height: 15px;
          border-radius: 3px;
          &::after {
            width: 4px;
            height: 8px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg) translate(-50%, -50%);
            left: 4px;
            top: 50%;
          }
        }
      }
    }
  }
}

.checkbox-md {
  .check-wrapper__item {
    .container2 {
      .check {
        .checkmark {
          width: 20px;
          height: 20px;
          border-radius: 3px;
          &::after {
            width: 5px;
            height: 10px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg) translate(-50%, -50%);
            left: 5px;
            top: 50%;
          }
        }
        .name {
          left: 35px;
        }
      }
    }
  }
}

.checkbox-lg {
  .check-wrapper__item {
    .container2 {
      .check {
        .checkmark {
          width: 25px;
          height: 25px;
          border-radius: 3px;
          &::after {
            width: 6px;
            height: 12px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg) translate(-50%, -50%);
            left: 6px;
            top: 50%;
          }
        }
        .name {
          left: 35px;
        }
      }
    }
  }
}
</style>
